<template>
    <div>
      <!-- Modal/upload component starts -->
      <base-modal name="UploadCreateModal">
        <template #body>
          <div class="mt-50">
            <div class="flex items-center justify-between">
              <h6 class="profile-header-text">{{ $t('set_new_photo') }}</h6>
              <div
                class="cursor-pointer p-5 border-2 rounded-sm border-default"
                @click="closeModal('UploadCreateModal')"
              >
                <ClearIcon />
              </div>
            </div>
            <div></div>
            <div class="profile-uploader">
              <div class="w-150 h-150">
                <upload-profile-preview
                  @fileUrl="getProfileUrl"
                  :isLabelShow="labelShow"
                  :isUploading="isUploading"
                  :uploadPercent="uploadPercent"
                  :uploadedAvatar="avatarImage"
                  ref="uploadFile"
                >
                  <template #text v-if="isUploading">
                    {{ $t('uploading', { percent: uploadPercent }) }}%
                  </template>
                  <template #text v-else>
                    {{ $t('upload') }}
                  </template>
                </upload-profile-preview>
              </div>
            </div>
          </div>
        </template>
        <template #action>
          <div class="button-grid">
            <base-button
              class="w-full"
              buttonType="danger-outline"
              width="169"
              @click.native="deleteProfilePicture"
              :disabled="!isDeleteAble"
            >
              <template #text>
                {{ $t('delete') }}
              </template>
            </base-button>
            <base-button
              class="w-full"
              buttonType="primary"
              width="169"
              @click.native="closeModal('UploadCreateModal')"
              v-if="!!file"
              :disabled="isUploading"
            >
              <template #text>
                <span>
                  {{ $t('done') }}
                </span>
              </template>
            </base-button>
            <base-button
              class="w-full"
              buttonType="primary"
              width="169"
              @click.native="closeModal('UploadCreateModal')"
              v-else
            >
              <template #text>
                <span>
                  {{ $t('save') }}
                </span>
              </template>
            </base-button>
          </div>
        </template>
      </base-modal>
    </div>
  </template>

  <script>
  import BaseButton from '@/components/base/BaseButton.vue';
  import ClearIcon from '@/assets/icons/vue/close_normal.vue';
  import uploadProfilePreview from '@/components/UploadProfilePreview.vue';
  import BaseModal from '@/components/modals/BaseModal.vue';
  import { mapGetters } from 'vuex';

  export default {
    name: 'UploadCreateModal',
    props: {
      avatar: {
        type: String,
        default: '',
      },
      hasProfile: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        file: null,
        uploadPercent: 0,
        isUploading: false,
        avatarImage: '',
      };
    },
    components: {
      uploadProfilePreview,
      BaseModal,
      ClearIcon,
      BaseButton,
    },
    mounted() {
      this.avatarImage = this.avatar ? this.avatar : '';
    },
    watch: {
      avatar() {
        this.avatarImage = this.avatar ? this.avatar : '';
      },
    },
    computed: {
      ...mapGetters({
        AdminPanelItemData: 'getAdminPanelItemData',
      }),
      labelShow: {
        get() {
          return !this.hasProfile;
        },
        set() {
          return !this.hasProfile;
        },
      },
      isDeleteAble() {
        return !!this.uploadedAvatar;
      },
      uploadedAvatar() {
        return this.avatarImage ? this.avatarImage : '';
      },
    },
    methods: {
      getProfileUrl(event) {
        this.file = event;
        if (this.file) {
          this.saveProfileImage();
        }
      },
      saveProfileImage() {
        this.$emit('imageFile', this.file);
      },
      closeModal(name) {
        this.$store.dispatch('modal/close', name);
        this.labelShow = true;
      },
    },
  };
  </script>

  <style lang="css" scoped>
  .profile-uploader {
    @apply my-50 flex justify-center items-center;
  }
  .profile-header-text {
    @apply font-semibold text-24 text-title;
  }
  .button-grid {
    @apply grid grid-cols-2 gap-20;
  }
  </style>
